// Used to discriminate client-side routes with regular "page reload" links
// See also: https://brewery.xing.io/link-manager
export const internalPaths = [
  /^\/([?]|$)/i,
  /^\/business-solutions([/?]|$)/i,
  /^\/chats([/?]|$)/i,
  /^\/discover([/?]|$)/i,
  /^\/insights([/?]|$)/i,
  /^\/jobs\/[^/]+-\d+([/?]|$)/i,
  /^\/jobs\/[^/]+-\d+\/contacts([/?]|$)/i,
  /^\/jobs\/apply([/?]|$)/i,
  /^\/jobs\/external-apply([/?]|$)/i,
  /^\/jobs\/find([/?]|$)/i,
  /^\/jobs\/my-jobs([/?]|$)/i,
  /^\/jobs\/quick-apply([/?]|$)/i,
  /^\/jobs\/search([/?]|$)/i,
  /^\/jobseeker-criteria([/?]|$)/i,
  /^\/karriere-ratgeber([/?]|$)/i,
  /^\/lebenslauf([/?]|$)/i,
  /^\/network([/?]|$)/i,
  /^\/network-home([/?]|$)/i,
  /^\/notifications([/?]|$)/i,
  /^\/onboarding([/?]|$)/i,
  /^\/preferences([/?]|$)/i,
  /^\/premium([/?]|$)/i,
  /^\/profile([/?]|$)/i,
  /^\/projobs([/?]|$)/i,
  /^\/recruiting\/jobs([/?]|$)/i,
  /^\/settings([/?]|$)/i,
  /^\/support\/contact([/?]|$)/i,
  /^\/xingternal([/?]|$)/i,
  /^\/search\/companies([/?]|$)/i,
  /^\/search\/members([/?]|$)/i,
  /^\/xam([/?]|$)/i,
];
